import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function RamIdSelection(props) {
  const { headers, fields, field, handleRamAssetNumberFieldKey, asset_number_field_key } = props;

  const handleChange = (e) => {
    handleRamAssetNumberFieldKey(e);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">
        Pilih Kolom Nomor Aset
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={asset_number_field_key}
        label="Pilih Kolom Nomor Aset"
        onChange={handleChange}
      >
        {headers && headers
          ?.filter((item) => item?.headerName !== field?.name)
          ?.map((item, index) => {
            const { headerName, field } = item;
            return (
              <MenuItem key={index} value={field}>
                {headerName}
              </MenuItem>
            );
          })}
        {fields && fields
          ?.filter((item) => item?.name !== field?.name && !item?.parent_uuid)
          ?.map((item, index) => {
            const { name, key } = item;
            return (
              <MenuItem key={index} value={key}>
                {name}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
}
